// removed by extract-text-webpack-plugin
module.exports = {"main":"_26kgZ-bD95aZs631MTeyDn","description":"VZwfi5aB1W4lpdaie6Zx7","controls":"_3GxiOECQn7madC5kRgnSF6","control":"_17aBzPd1AmO8-xkVJxoMoa","metadatas":"_2jLU95vNnNnv-aH9vkaMZ4","metadata":"GjrR9JPp6evTOc6VsVOq9","noMatch":"_2s39Wai7V87jM3yFAkSzm5","noMatchText":"_15K4gyJ80YIfUURnmNaroi"};


//////////////////
// WEBPACK FOOTER
// ./components/Catalog/Overview.module.css
// module id = 2337
// module chunks = 1